<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: 'MaterialdisposalLst/OurMaterial' }"
            >我的订单列表</el-breadcrumb-item
          >
          <el-breadcrumb-item>我的订单</el-breadcrumb-item>
        </el-breadcrumb>
        <h4 class="account-card-title">我的订单</h4>
      </div>
      <div class="titleone"></div>
      <div class="title">
        <p class="titlespan"></p>
        成交订单信息
      </div>
      <el-form :model="formself" ref="formself" label-width="150px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="公告标题:">
              <span>{{ formself.noticeTitle }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="1">
            <el-form-item label="公告编号:">
              <span>{{ formself.noticeCode }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="价格类型:">
              <span>{{
                formself.bidCode == '10' ? '含税总价' : '含税单价'
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="1">
            <el-form-item label="成交时间:">
              <span>{{ formself.dealTime }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="labelV">
              <span>{{ formself.dealPrice | numberFormat(2) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="1">
            <el-form-item label="买受人:">
              <span>{{ formself.buyerCompName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发货进度:">
              <span>{{
                formself.statusCode === '0'
                  ? '未发货'
                  : formself.statusCode === '1'
                  ? '发货中'
                  : '发货完成'
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="1">
            <el-form-item :label="bidCodeV" v-if="formself.bidCode == '05'">
              <span>{{ formself.shipmentsTotalPrice | numberFormat(2) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        :data="shipmentsAllMatelist"
        border
        style="width: 70%"
        class="tableData"
      >
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="mateName" label="物资描述" width="180">
        </el-table-column>
        <el-table-column prop="unitName" label="计量单位"> </el-table-column>
        <el-table-column prop="fixedMateAmount" label="预估数量">
          <template slot-scope="scope">
            <span>{{
              scope.row.fixedMateAmount === null
                ? '0'
                : scope.row.fixedMateAmount | numberFormat(3)
            }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="shipmentsAmount" label="累计发货数量">
          <template slot-scope="scope">
            <span>{{
              scope.row.shipmentsAmount === null
                ? '0'
                : scope.row.shipmentsAmount | numberFormat(3)
            }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="newShipmentsAmount" :label="labelV">
            <template slot-scope="scope">
           
              <span>{{scope.row.newShipmentsAmount| numberFormat(3)}}</span>
        
            </template>
          </el-table-column> -->
        <el-table-column
          prop="shipmentsWhether"
          label="发货进度"
          align="center"
        >
          <template slot-scope="scope">
            {{
              scope.row.shipmentsWhether === 1
                ? '发货完成'
                : scope.row.shipmentsAmount === null
                ? '未发货'
                : '发货中'
            }}
          </template>
        </el-table-column>
      </el-table>
      <div class="titleone"></div>
      <div class="title">
        <p class="titlespan"></p>
        发货登记记录表
      </div>
      <el-table :data="modify" border style="width: 70%" class="tableData">
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="code" label="发货登记编号" width="180">
        </el-table-column>
        <el-table-column
          prop="shipmentsTime"
          label="发货登记日期"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="createPerson" label="经办人" align="center">
        </el-table-column>
        <el-table-column prop="unitName" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >修改</el-button
            >
            <el-button type="text" size="small" @click="handleClickD(scope)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="登记发货信息"
        :visible.sync="dialogFormVisible"
        width="80%"
        center
        top="8vh"
        :modal-append-to-body="false"
      >
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="150px"
          size="small"
        >
          <el-row :gutter="20">
            <el-col :span="11">
              <el-form-item
                label="发货日期:"
                prop="shipmentsTime"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-date-picker
                  v-model="ruleForm.shipmentsTime"
                  type="date"
                  placeholder="选择日期时间"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                label="发货地址:"
                prop="shipmentsAddress"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-input v-model="ruleForm.shipmentsAddress"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="21">
              <el-form-item label="发货说明:">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="填写过磅地，司磅人，监磅人，车号等相关信息"
                  v-model="ruleForm.remark"
                  maxlength="200"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="发货单照片:">
            <template slot="label">
              发货单照片
              <el-tooltip effect="light" placement="top-start">
                <template slot="content">
                  可上传doc、docx、xls、xslx、pdf格式文件，最多3个文件，每个文件不超过5M
                </template>
                <i class="el-icon-question table-worming">&nbsp;</i>
              </el-tooltip>
              :
            </template>
            <on-price
              typeV="money"
              :multiple="true"
              accept="*"
              :type="'primary'"
              @fileDataSingle="noticeFiles"
              :fileList="ruleForm.noticeFiles"
            ></on-price>
          </el-form-item>
          <el-table
            :data="ruleForm.shipmentsMate"
            border
            style="width: 70%"
            class="tableData"
          >
            <el-table-column type="index" label="序号" width="50">
            </el-table-column>
            <el-table-column prop="mateName" label="物资描述" width="180">
            </el-table-column>
            <el-table-column prop="unitName" label="计量单位">
            </el-table-column>
            <!-- <el-table-column prop="fixedMateAmount" label="预估数量">
              <template slot-scope="scope">
                <span
                  >{{
                    scope.row.fixedMateAmount === null
                      ? '0'
                      : scope.row.fixedMateAmount | numberFormat(3)
                  }}{{ scope.row.unitName }}</span
                >
              </template>
            </el-table-column> -->

            <!-- <el-table-column prop="shipmentsAmount" label="累计发货数量">
              <template slot-scope="scope">
                <span
                  >{{
                    scope.row.shipmentsAmount === null
                      ? '0'
                      : scope.row.shipmentsAmount | numberFormat(3)
                  }}{{ scope.row.unitName }}</span
                >
              </template>
            </el-table-column> -->

            <el-table-column prop="newShipmentsAmount" label="本次发货数量">
              <template slot-scope="scope">
                <el-form-item
                  class="tableform"
                  :prop="
                    'shipmentsMate.' + scope.$index + '.newShipmentsAmount'
                  "
                  :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                >
                  <el-input
                    v-model="scope.row.newShipmentsAmount"
                    size="mini"
                    @blur="validationdeposit(scope)"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="shipmentsWhether"
              label="发货完成"
              align="center"
              width="80px"
            >
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.shipmentsWhether"
                  :true-label="1"
                  :false-label="0"
                ></el-checkbox>
              </template>
            </el-table-column>
          </el-table>

          <div class="titleone"></div>
          <div class="title">
            <p class="titlespan"></p>
            经办人信息
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="联系人:"
                prop="contName"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-input v-model="ruleForm.contName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="5">
              <el-form-item label="传真:" prop="contFax">
                <el-input v-model="ruleForm.contFax"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="手机/电话:"
                prop="contPhone"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-input v-model="ruleForm.contPhone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="5">
              <el-form-item
                label="邮箱:"
                prop="contEmail"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-input v-model="ruleForm.contEmail"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <div class="add" @click="add">+添加发货登记</div> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submit('ruleForm', 1, 2)"
            >提交</el-button
          >
          <el-button @click="dialogFormVisible = false">关闭</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="修改登记发货信息"
        :visible.sync="dialogModifyVisible"
        width="80%"
        center
        top="8vh"
        :modal-append-to-body="false"
      >
        <el-form
          :model="ruleFormModify"
          ref="ruleFormModify"
          label-width="150px"
          size="small"
        >
          <el-row :gutter="20">
            <el-col :span="11">
              <el-form-item
                label="发货日期:"
                prop="shipmentsTime"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-date-picker
                  v-model="ruleFormModify.shipmentsTime"
                  type="date"
                  placeholder="选择日期时间"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                label="发货地址:"
                prop="shipmentsAddress"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-input v-model="ruleFormModify.shipmentsAddress"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="21">
              <el-form-item label="发货说明:">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="填写过磅地，司磅人，监磅人，车号等相关信息"
                  v-model="ruleFormModify.remark"
                  maxlength="200"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="发货单照片:">
            <template slot="label">
              发货单照片
              <el-tooltip effect="light" placement="top-start">
                <template slot="content">
                  可上传doc、docx、xls、xslx、pdf格式文件，最多3个文件，每个文件不超过5M
                </template>
                <i class="el-icon-question table-worming">&nbsp;</i>
              </el-tooltip>
              :
            </template>
            <on-price
              typeV="money"
              :multiple="true"
              accept="*"
              :type="'primary'"
              @fileDataSingle="noticeFilesModify"
              :fileList="ruleFormModify.noticeFiles"
            ></on-price>
          </el-form-item>
          <el-table
            :data="ruleFormModify.shipmentsMate"
            border
            style="width: 70%"
            class="tableData"
          >
            <el-table-column type="index" label="序号" width="50">
            </el-table-column>
            <el-table-column prop="mateName" label="物资描述" width="180">
            </el-table-column>
            <el-table-column prop="unitName" label="计量单位">
            </el-table-column>
            <!-- <el-table-column prop="fixedMateAmount" label="预估数量">
              <template slot-scope="scope">
                <span
                  >{{
                    scope.row.fixedMateAmount === null
                      ? '0'
                      : scope.row.fixedMateAmount | numberFormat(3)
                  }}{{ scope.row.unitName }}</span
                >
              </template>
            </el-table-column>

            <el-table-column prop="shipmentsAmount" label="累计发货数量">
              <template slot-scope="scope">
                <span
                  >{{
                    scope.row.shipmentsAmount === null
                      ? '0'
                      : scope.row.shipmentsAmount | numberFormat(3)
                  }}{{ scope.row.unitName }}</span
                >
              </template>
            </el-table-column> -->

            <el-table-column prop="newShipmentsAmount" label="累计发货数量">
              <template slot-scope="scope">
                <el-form-item
                  class="tableform"
                  :prop="
                    'shipmentsMate.' + scope.$index + '.newShipmentsAmount'
                  "
                  :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                >
                  <el-input
                    v-model="scope.row.newShipmentsAmount"
                    size="mini"
                    @blur="validationdeposit1(scope)"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="shipmentsWhether"
              label="发货完成"
              align="center"
              width="80px"
            >
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.shipmentsWhether"
                  :true-label="1"
                  :false-label="0"
                ></el-checkbox>
              </template>
            </el-table-column>
          </el-table>

          <div class="titleone"></div>
          <div class="title">
            <p class="titlespan"></p>
            经办人信息
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="联系人:"
                prop="contName"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-input v-model="ruleFormModify.contName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="5">
              <el-form-item label="传真:" prop="contFax">
                <el-input v-model="ruleFormModify.contFax"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="手机/电话:"
                prop="contPhone"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-input v-model="ruleFormModify.contPhone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="5">
              <el-form-item
                label="邮箱:"
                prop="contEmail"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-input v-model="ruleFormModify.contEmail"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <div class="add" @click="add">+添加发货登记</div> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submit('ruleFormModify', 1, 1)"
            >提交</el-button
          >
          <el-button @click="dialogModifyVisible = false">关闭</el-button>
        </div>
      </el-dialog>
      <div class="add" @click="dialogFormVisible = true">+添加发货登记</div>
    </div>
    <div class="primary">
      <!-- <el-button @click="submit('ruleForm', 0)">保存</el-button> -->
      <el-button @click="back" type="primary">返回</el-button>
    </div>
  </div>
</template>
<script>
import utils from '@/utils/filters'
export default {
  data() {
    return {
      shipmentsAllMatelist: [],
      ruleFormModify: {},
      modify: [],
      dialogModifyVisible: false,
      dialogFormVisible: false,
      labelV: '成交价(元):',
      bidCodeV: '',
      formself: {},
      ruleForm: {
        ruleForm: '',
        shipmentsTime: '',
        shipmentsAddress: '',
        noticeFiles: [],
        contName: '',
        contFax: '',
        contPhone: '',
        contEmail: '',
        fileIdsshipments: '',
        shipmentsMate: []
      }
    }
  },
  computed: {
    typeId() {
      return this.$route.query.id
    }
  },
  created() {
    this.sellerOrderGet()
    this.shipmentsMatelist()
    this.shipmentsList()
    this.shipmentsAllMatelistfun()
  },
  methods: {
    async shipmentsAllMatelistfun() {
      let data = await this.$api.materialdisposal.shipmentsAllMatelist({
        orderId: this.typeId,
        shipmentsId: null
      })
      this.shipmentsAllMatelist = data.data
    },
    //物资
    async shipmentsMatelist() {
      let data = await this.$api.materialdisposal.shipmentsMatelist({
        orderId: this.typeId,
        shipmentsId: null
      })
      console.log(data)
      this.ruleForm.shipmentsMate = data.data
    },
    //初始化
    async sellerOrderGet() {
      let data = await this.$api.materialdisposal.sellerOrderGet({
        id: this.typeId
      })
      this.formself = data
      if (this.formself.bidCode == '05') {
        this.labelV = '成交价' + '(元/' + data.unitName + '):'
        this.bidCodeV = '累积已发货金额' + '(元/' + data.unitName + ')'
      }
    },
    async shipmentsList() {
      let data = await this.$api.materialdisposal.shipmentsList({
        orderId: this.typeId
      })
      this.modify = data.data
      // obj.grade["Chinese"] = obj.grade.Math;
    },
    validationdeposit1(o) {
      if (o.row.newShipmentsAmount === '0') {
        this.ruleFormModify.shipmentsMate[
          o.$index
        ].newShipmentsAmount = utils.numberFormat(
          this.ruleFormModify.shipmentsMate[o.$index].newShipmentsAmount,
          3
        )
        return
      }
      if (!Number(o.row.newShipmentsAmount)) {
        this.ruleFormModify.shipmentsMate[o.$index].newShipmentsAmount = null
        this.$message.error('请输入数字')
        return false
      }

      this.ruleFormModify.shipmentsMate[
        o.$index
      ].newShipmentsAmount = utils.numberFormat(
        this.ruleFormModify.shipmentsMate[o.$index].newShipmentsAmount,
        3
      )
    },
    validationdeposit(o) {
      if (o.row.newShipmentsAmount === '0') {
        this.ruleForm.shipmentsMate[
          o.$index
        ].newShipmentsAmount = utils.numberFormat(
          this.ruleForm.shipmentsMate[o.$index].newShipmentsAmount,
          3
        )
        return
      }
      if (!Number(o.row.newShipmentsAmount)) {
        this.ruleForm.shipmentsMate[o.$index].newShipmentsAmount = null
        this.$message.error('请输入数字')
        return false
      }

      this.ruleForm.shipmentsMate[
        o.$index
      ].newShipmentsAmount = utils.numberFormat(
        this.ruleForm.shipmentsMate[o.$index].newShipmentsAmount,
        3
      )
    },
    noticeFiles(val) {
      this.ruleForm.noticeFiles = val
    },
    noticeFilesModify(val) {
      this.ruleFormModify.noticeFiles = val
    },
    add() {},
    async handleClick(o) {
      let data = await this.$api.materialdisposal.shipments({
        id: o.id
      })
      this.ruleFormModify = data

      this.ruleFormModify['shipmentsMate'] = this.ruleFormModify.mates
      this.ruleFormModify['noticeFiles'] = this.ruleFormModify.files
      if (this.ruleFormModify.noticeFiles === null) {
        this.ruleFormModify.noticeFiles = []
      }
      this.ruleFormModify.noticeFiles.map(item => {
        item.name = item.fileName
      })
      this.ruleFormModify.shipmentsMate.map(item => {
        item.newShipmentsAmount = utils.numberFormat(item.newShipmentsAmount, 3)
      })
      this.dialogModifyVisible = true
    },
    handleClickD(o) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.shipmentsDelete(o)
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    async shipmentsDelete(o) {
      let data = await this.$api.materialdisposal.shipmentsDelete({
        id: o.row.id
      })
      if (data) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        setTimeout(function() {
          window.location.reload()
        }, 1000)
      }
    },
    //提交
    async saveShipments(o) {
      if (this.ruleForm.noticeFiles.length === 1) {
        this.ruleForm.fileIdsshipments = this.ruleForm.noticeFiles[0].fileId.toString()
      } else {
        this.ruleForm.noticeFiles.map((item, index) => {
          if (index === 0) {
            this.ruleForm.fileIdsshipments = item.fileId
          } else {
            this.ruleForm.fileIdsshipments =
              this.ruleForm.fileIdsshipments + ',' + item.fileId
          }
        })
      }
      this.ruleForm.shipmentsMate.map(item => {
        if (item.newShipmentsAmount) {
          item.newShipmentsAmount = item.newShipmentsAmount.replace(/,/g, '')
        }
      })
      // delete this.ruleForm.noticeFiles
      let data = await this.$api.materialdisposal.saveShipments({
        ...this.ruleForm,
        statusCode: o,
        orderId: this.typeId
      })
      console.log(data, o)
      if (data) {
        this.$message.success('提交成功')
        setTimeout(function() {
          window.location.reload()
        }, 1000)
        // this.$router.push({ name: 'OrderManagement' })
      }
    },
    async saveShipmentsq(o) {
      if (this.ruleFormModify.noticeFiles.length === 1) {
        this.ruleFormModify.fileIdsshipments = this.ruleFormModify.noticeFiles[0].fileId.toString()
      } else {
        this.ruleFormModify.noticeFiles.map((item, index) => {
          if (index === 0) {
            this.ruleFormModify.fileIdsshipments = item.fileId
          } else {
            this.ruleFormModify.fileIdsshipments =
              this.ruleFormModify.fileIdsshipments + ',' + item.fileId
          }
        })
      }
      this.ruleFormModify.shipmentsMate.map(item => {
        if (item.newShipmentsAmount) {
          item.newShipmentsAmount = item.newShipmentsAmount.replace(/,/g, '')
        }
      })
      // delete this.ruleForm.noticeFiles
      let data = await this.$api.materialdisposal.saveShipments({
        id: this.ruleFormModify.id,
        shipmentsTime: this.ruleFormModify.shipmentsTime,
        shipmentsAddress: this.ruleFormModify.shipmentsAddress,
        noticeFiles: this.ruleFormModify.noticeFiles,
        contName: this.ruleFormModify.contName,
        contFax: this.ruleFormModify.contFax,
        contPhone: this.ruleFormModify.contPhone,
        contEmail: this.ruleFormModify.contEmail,
        fileIdsshipments: this.ruleFormModify.fileIdsshipments,
        shipmentsMate: this.ruleFormModify.shipmentsMate,
        // ...this.ruleFormModify,
        statusCode: o,
        orderId: this.typeId
      })
      console.log(data, o)
      if (data === 0) {
        this.$message.success('提交成功')
        this.dialogModifyVisible = false
        setTimeout(function() {
          window.location.reload()
        }, 1000)
      }
    },
    submit(ruleForm, o, q) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          if (q == 1) {
            this.saveShipmentsq(o)
          } else {
            this.saveShipments(o)
          }
          // this.saveShipments(o,q)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //返回
    back() {
      this.$router.push({ name: 'OrderManagement' })
    }
  }
}
</script>
<style lang="less" scoped>
.titleone {
  margin: 5px;
  margin-top: 15px;
  width: 10px;
  height: 22px;
  background: #2587ff;
  float: left;
}
.title {
  padding: 10px;
  height: 30px;
  margin-top: 10px;
  margin-bottom: 20px;
  background: #ecf5ff;
  font-size: 15px;
  line-height: 15px;
}
.tableData {
  margin-left: 150px;
}
.primary {
  margin-left: 47%;
  margin-top: 40px;
  margin-bottom: 20px;
}
.add {
  width: 70%;
  height: 40px;
  border: 1px #2587ff dashed;
  text-align: center;
  color: royalblue;
  padding: 10px;
  margin-left: 150px;
  margin-bottom: 20px;
  cursor: pointer;
  margin-top: 20px;
}
/deep/.tableform {
  margin-bottom: 0 !important;
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
